import { render } from "./ScDataTableReportsItem.vue?vue&type=template&id=18013176"
import script from "./ScDataTableReportsItem.vue?vue&type=script&lang=js"
export * from "./ScDataTableReportsItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Reports/ScDataTableReportsItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18013176"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18013176', __exports__)) {
    console.log('reload')
    api.reload('18013176', __exports__)
  }
  
  module.hot.accept("./ScDataTableReportsItem.vue?vue&type=template&id=18013176", () => {
    console.log('re-render')
    api.rerender('18013176', render)
  })

}


export default __exports__